__turbopack_context__.v({
  "body": "stageZero-module-scss-module__6KQOIW__body",
  "breederLine": "stageZero-module-scss-module__6KQOIW__breederLine",
  "card": "stageZero-module-scss-module__6KQOIW__card",
  "ctas": "stageZero-module-scss-module__6KQOIW__ctas",
  "eyebrow": "stageZero-module-scss-module__6KQOIW__eyebrow",
  "heading": "stageZero-module-scss-module__6KQOIW__heading",
  "point": "stageZero-module-scss-module__6KQOIW__point",
  "pointIcon": "stageZero-module-scss-module__6KQOIW__pointIcon",
  "pointLabel": "stageZero-module-scss-module__6KQOIW__pointLabel",
  "pointText": "stageZero-module-scss-module__6KQOIW__pointText",
  "points": "stageZero-module-scss-module__6KQOIW__points",
  "primaryCta": "stageZero-module-scss-module__6KQOIW__primaryCta",
  "secondaryCta": "stageZero-module-scss-module__6KQOIW__secondaryCta",
  "section": "stageZero-module-scss-module__6KQOIW__section",
});
